/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_LeadInputs */

const en_dr_proof_lead = /** @type {(inputs: Dr_Proof_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The PRD's "Origin & hypotheses" section links a hypothesis to the acceptance criteria that test it, and the criteria's status is read straight from \`bystep task verify\` — not typed in by hand.`)
};

const id_dr_proof_lead = /** @type {(inputs: Dr_Proof_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seksi "Asal-usul & hipotesis" di PRD menautkan satu hipotesis ke kriteria penerimaan yang mengujinya, dan status kriteria itu dibaca langsung dari \`bystep task verify\` — bukan diketik manual.`)
};

/**
* | output |
* | --- |
* | "The PRD's \"Origin & hypotheses\" section links a hypothesis to the acceptance criteria that test it, and the criteria's status is read straight from `bystep t..." |
*
* @param {Dr_Proof_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_lead = /** @type {((inputs?: Dr_Proof_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_lead(inputs)
	return en_dr_proof_lead(inputs)
});